module.exports = __webpack_public_path__ + "img/berlinerkranse_raw_folded.a70bc11e.jpg";